import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Box, CircularProgress, BoxProps } from '@mui/material';

const Column = styled(Box)`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const WidthLimiter = ({
	children,
	maxWidth,
	p,
	center,
	minHeight,
	...rest
}: {
	children: JSX.Element | JSX.Element[] | (JSX.Element | null)[] | null;
	maxWidth?: string;
	p?: string;
	center?: boolean;
	minHeight?: string;
} & BoxProps): JSX.Element => {
	return (
		<Column minHeight={!children ? '10rem' : minHeight} p={p}>
			<Box
				width="100%"
				flex="1"
				display="flex"
				{...rest}
				maxWidth={maxWidth}
				justifyContent={!children || center ? 'center' : 'flex-start'}
				alignItems={!children || center ? 'center' : 'flex-start'}
			>
				<>{!children ? <CircularProgress /> : children}</>
			</Box>
		</Column>
	);
};

export default React.memo(WidthLimiter);
